var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"fixed":!_vm.heroIsVisible}}),_c('router-view',{attrs:{"heroIsVisible":_vm.heroIsVisible},on:{"update:heroIsVisible":function($event){_vm.heroIsVisible=$event},"update:hero-is-visible":function($event){_vm.heroIsVisible=$event}}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }